const drawer = document.querySelector('[data-region-drawer]');

// Same cookie contract as mwc-geo-suggestion.js. An explicit pick in the drawer must silence
// the geo suggestion, otherwise the banner would keep offering a region the visitor just chose.
const COOKIE = 'mwc_region_choice';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

function remember(region) {
  document.cookie = `${COOKIE}=${region}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

function open() {
  if (typeof drawer.showModal === 'function') {
    drawer.showModal();
  } else {
    drawer.setAttribute('open', '');
  }

  if (drawer.hasAttribute('data-scroll-lock-required')) {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
  }
}

function close() {
  drawer.close();
}

if (drawer) {
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-region-drawer-toggle]');
    if (!toggle) return;
    event.preventDefault();
    open();
  });

  drawer.querySelectorAll('[data-region-drawer-close]').forEach((button) => {
    button.addEventListener('click', close);
  });

  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) close();
  });

  drawer.addEventListener('close', () => {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  });

  drawer.querySelectorAll('[data-region-choice]').forEach((link) => {
    link.addEventListener('click', () => remember(link.dataset.regionChoice));
  });

  // The v5 drawer stripped `?country=` on load because its cross-store links used it. The
  // Switzerland link now uses the /en-ch market path, but a stale `?country=` can still arrive
  // from an old bookmark or an inbound link, so keep clearing it.
  const url = new URL(window.location.href);
  if (url.searchParams.has('country')) {
    url.searchParams.delete('country');
    history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  }
}
